<template>
  <div class="app-container">
    <BjDivider>
      <!-- {{ $t('BusinessPurchaseEntryComView.purchase') }} {{ text }} {{ $t('BusinessPurchaseEntryComView.statusText') }} -->
      {{ $t('BusinessPurchaseEntryComView.purchase') }}{{ $t('BusinessPurchaseEntryComView.informationText') }}
      <template #right>
        <el-dropdown v-hasDropdownChildren @command="exportFiles">
            <el-button type="primary">
              {{ $t('exportText') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="outPutPdfFn"> {{ $t('BusinessPurchaseEntryComPage.outPutPdfFn') }} </el-dropdown-item>
              <el-dropdown-item command="outPutExcel"> {{ $t('BusinessPurchaseEntryComPage.outPutExcel') }} </el-dropdown-item>
              <el-dropdown-item v-if="data.purchaseType!=='COMMON'" command="auOutPutPdfFn"> {{ $t('BusinessPurchaseEntryComPage.auOutPutPdfFn') }} </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <el-button v-if="pageType === 'inform'" type="primary" @click="showLog">{{ $t('BusinessPurchaseEntryComView.operationLog') }}</el-button>
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <PdfTemplate id="pdfRef" ref="pdfRef" :data="data"></PdfTemplate>
    <!-- <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <div class="bj-form-title">
          {{ $t('BusinessPurchaseEntryComView.statusMeaning') }}： <span class="red">{{ $t(INCOMING_TYPE.bjGet(data.status)) }}</span>
        </div>
        <div class="flex-center">
          <div v-show="pageType === 'inform'" class="text-center numBox">
            <p>{{ $t('BusinessPurchaseEntryComView.inform') }}</p>
            <span>{{ data.planQty || 0 }}</span>
          </div>
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseEntryComView.alreadyQty') }}</p>
            <span>{{ data.alreadyQty || 0 }}</span>
          </div>
          <div v-show="pageType === 'inform'" class="text-center numBox">
            <p>{{ $t('BusinessPurchaseEntryComView.waitQty') }}</p>
            <span>{{ data.waitQty || 0 }}</span>
          </div>
          <div v-show="pageType === 'inform'" class="text-center numBox">
            <p>{{ $t('BusinessPurchaseOrderList.tolerance') }}</p>
            <span>{{ data.waitQty || 0 }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="bj-row mt20">
      <div class="bj-col-12" style="padding-left: 0">
        <template>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseEntryComPage.code') }}</div>
            <div class="bj-form-item-value">
              {{ pageType === 'inform' ? data.code : data.stockinCode }}
            </div>
          </div>
          <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsCom.purchaseCode') }}</div>
          <div class="bj-form-item-value">{{ data.purchaseCode }}</div>
        </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.type') }}</div>
            <div class="bj-form-item-value">{{ $t(PURCHASE_TYPE.bjGet(data.purchaseType)) }}</div>
          </div>
        </template>
<!--        <div class="bj-form-item">-->
<!--          <div class="bj-form-item-label">入库类型</div>-->
<!--          <div class="bj-form-item-value">{{ data.typeMeaning }}</div>-->
<!--        </div>-->
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseEntryComView.supplierName') }}</div>
          <div class="bj-form-item-value">{{ data.supplierName }}</div>
        </div>
         <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BjDialogListConfig.Suppliercode') }}</div>
          <div class="bj-form-item-value">{{ data.supplierCode }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsCom.invoiceNo') }}</div>
          <div class="bj-form-item-value">{{ data.invoiceNo }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('table.creatorText') }}</div>
          <div class="bj-form-item-value">{{ data.createdName }}</div>
        </div>
        <!-- <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseEntryComView.warehouseName') }}</div>
          <div class="bj-form-item-value">{{ data.warehouseName }}</div>
        </div> -->

      </div>
      <div class="bj-col-12">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('table.createTimeText') }}</div>
          <div class="bj-form-item-value">{{ data.creationDate }}</div>
        </div>
        <div v-if="pageType === 'inform'" class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.postingDate') }}</div>
          <div class="bj-form-item-value">{{ data.requiredDate }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.documentDate') }}</div>
          <div class="bj-form-item-value">{{ data.documentDate }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsCom.PO.loosDate') }}</div>
          <div class="bj-form-item-value">{{ data.loosDate }}</div>
        </div>

        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseEntryComPage.applyCode') }}</div>
          <div class="bj-form-item-value">{{ data.applyCode }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.vendorRefNo') }}</div>
          <div class="bj-form-item-value">{{ data.vendorRefNo }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('table.remarkText') }}</div>
          <div class="bj-form-item-value">{{ data.remark }}</div>
        </div>
      </div>
    </div>
    <BjDivider>
      {{ $t('BusinessPurchaseEntryComView.table.title') }}
    </BjDivider>
    <template>
      <el-table :data="data.goodsList" border script max-height="600px">
        <el-table-column prop="contractNo" label="合同号" align="center" width="175" />
        <el-table-column prop="skuCode" label="SKU" align="center" width="180" />
        <el-table-column prop="planQty" label="已出货数量" align="center" width="150" />
        <el-table-column prop="waitQty" label="已装船数量" align="center" width="150" />
        <el-table-column prop="alreadyQty" :label="$t('BusinessPurchaseEntryComPage.table.alreadyQty')" align="center" width="150" />
        <el-table-column prop="taxUnitPrice" :label="$t('BusinessPurchaseComponentsPur.table.UnitPrice')" align="center" width="130" />
        <el-table-column prop="currency" :label="$t('ChannelManagement.Header.currency')" align="center" width="130" />
        <!-- <el-table-column prop="discount" :label="$t('BusinessPurchaseComponentsPur.table.Discount')" align="center" width="120">
          <template slot-scope="{ row }">
            {{ row.discount }}%
          </template>
        </el-table-column>
        <el-table-column prop="taxCode" :label="$t('BusinessPurchaseComponentsPur.table.TaxCode')" align="center" width="100">
          <template slot-scope="{ row }">
            {{ row.taxCode }}
          </template>
        </el-table-column>
        <el-table-column prop="grossPriceAfterDisc" :label="$t('BusinessPurchaseComponentsPur.table.GrosSprice')" align="center" width="130">
        </el-table-column> -->
        <!-- <el-table-column prop="totalPrice" :label="$t('BusinessPurchaseComponentsPur.table.Total')" align="center" width="130">
        </el-table-column> -->
        <el-table-column :label="$t('BusinessPurchaseComponentsPur.table.Warehouse')" align="center" width="130">
          <template slot-scope="{ row }">
              {{ row.warehouseCode }}
          </template>
        </el-table-column>
        <el-table-column prop="length" :label="$t('BusinessPurchaseComponentsPur.table.Length')" align="center" width="130">
          <template slot-scope="{ row }">
            {{ row.length }} cm
          </template>
        </el-table-column>
        <el-table-column prop="width" :label="$t('BusinessPurchaseComponentsPur.table.Width')" align="center" width="130">
          <template slot-scope="{ row }">
            {{ row.width }} cm
          </template>
        </el-table-column>
        <el-table-column prop="height" :label="$t('BusinessPurchaseComponentsPur.table.Height')" align="center" width="130">
          <template slot-scope="{ row }">
            {{ row.height }} cm
          </template>
        </el-table-column>
        <el-table-column prop="volume" :label="$t('BusinessPurchaseComponentsPur.table.Volume')" align="center" width="130">
          <template slot-scope="{ row }">
            {{ isNaN(row.volume) ? '' : row.volume }}
          </template>
        </el-table-column>
        <el-table-column prop="volumeUnit" :label="$t('BusinessPurchaseComponentsPur.table.VolumeUnit')" align="center" width="120">
          cm³
        </el-table-column>
        <el-table-column prop="weight" :label="$t('BusinessPurchaseComponentsPur.table.Weight')" align="center" width="130">
          <template slot-scope="{ row }">
            {{ row.weight }} kg
          </template>
        </el-table-column>
        <!-- <el-table-column prop="uomCode" :label="$t('BusinessPurchaseComponentsPur.table.UomCode')" align="center" width="130">
        </el-table-column> -->
        </el-table>
    </template>
    <template v-if="data.purchaseType!=='COMMON'">
      <BjDivider>{{ $t('BusinessPurchaseComponentsPur.table.FreightInformation') }}</BjDivider>
        <el-table border script max-height="600px" :data="freight">
          <el-table-column prop="freightName" :label="$t('BusinessPurchaseComponentsPur.table.FreightName')" align="center" width="130"></el-table-column>
          <el-table-column prop="taxGroup" :label="$t('BusinessPurchaseComponentsPur.table.TaxGroup')" align="center">
          </el-table-column>
          <el-table-column prop="tax" :label="$t('BusinessPurchaseComponentsPur.table.Tax')" align="center">{{ data.taxRate }}</el-table-column>
          <el-table-column prop="netAmount" :label="$t('BusinessPurchaseComponentsPur.table.NetAmount')" align="center" width="160">
          </el-table-column>
          <el-table-column prop="distribMethod" :label="$t('BusinessPurchaseComponentsPur.table.DistribMethod')" align="center">
          </el-table-column>
          <el-table-column prop="totalTax" :label="$t('BusinessPurchaseComponentsPur.table.TotalTaxAmount')" align="center" width="160">
              {{ data.freightTax }}
          </el-table-column>
          <el-table-column prop="status" :label="$t('table.statusText')" align="center" width="120"></el-table-column>
          <el-table-column prop="grossAmount" :label="$t('BusinessPurchaseComponentsPur.table.GrossAmount')" align="center" width="160">
          </el-table-column>
        </el-table>
      </template>
    <!-- <div class="bj-form-tips" style="margin: 25px 0">
      <div><span class="mr20">Total Before Discount: <span class="font16 ml10">{{ totalBefore }}</span></span>  Total Payment Due:<span class="font16 ml10">{{ totalPayment }}</span> <template> <span class="ml25"></span> Tax:
        <span class="font16 ml10">{{ taxComputed }} </span></template></div>
    </div> -->
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { purchaseApi } from '@/api';
import orderLog from '@/utils/log.js';
import PdfTemplate from './pdfTemplate';
import { downloadBlob } from '@/utils/index';
import { PURCHASE_TYPE, INCOMING_TYPE } from '@/utils/constants';

export default {
  components: {
    PdfTemplate,
  },
  mixins: [viewMiXin],
  props: {
    pageType: {
      type: String,
      default: 'inform',
      validator: value => {
        return ['inform', 'result'].includes(value);
      },
    },
  },
  data() {
    return {
      PURCHASE_TYPE,
      INCOMING_TYPE,
      data: {},
      freight: [{
        freightName: 'FREIGHT',
        taxGroup: 'p1',
        tax: '10',
        totalTaxAmount: 0,
        distribMethod: 'Row Total',
        netAmount: 0,
        status: 'O',
        grossAmount: 0,
      }]
     };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    totalPayment () {
      if (this.data.goodsList) {
        // eslint-disable-next-line no-return-assign
        return this.data.goodsList.reduce((pre, item) => pre += item?.totalPrice, 0).toFixed(3);
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    taxComputed() {
      if (this.data.goodsList) {
        // eslint-disable-next-line no-return-assign
        const totalPrice = this.data.goodsList.reduce((pre, item) => {
          if (item.taxCode === 'p1') {
            // eslint-disable-next-line no-return-assign
            return pre += (item?.totalPrice * 1.1);
          } else {
            // eslint-disable-next-line no-return-assign
            return pre += item?.totalPrice;
          }
        }, 0);
        return totalPrice.toFixed(3);
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    totalBefore () {
      if (this.data.goodsList) {
        // eslint-disable-next-line no-return-assign
        return this.data.goodsList.reduce((pre, item) => pre += (item?.planQty * item?.taxUnitPrice), 0).toFixed(3);
      }
    },
    text() {
      return this.pageType === 'inform' ? this.$t('BusinessPurchaseEntryComView.notify') : this.$t('BusinessPurchaseEntryComView.result');
    },
  },
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    /** 导出 */
    outPutExcel() {
      purchaseApi['reportStockins']({code: this.$route.query.code}).then(
        res => {
          downloadBlob(
            res,
            (this.isInform ? this.$t('BusinessPurchaseEntryComPage.downName1') : this.$t('BusinessPurchaseEntryComPage.downName2')) +
              new Date().toLocaleString() +
              '.xlsx',
          );
        },
      );
    },
    getVolume(v) {
      return v?.length * v?.width * v?.height;
    },
    exportFiles(command) {
      switch (command) {
        case 'outPutPdfFn':
          this.outPutPdfFn();
          break;
        case 'outPutExcel':
          this.outPutExcel();
          break;
        case 'auOutPutPdfFn':
          this.auOutPutPdfFn();
          break;
      }
    },
    auOutPutPdfFn() {
      this.$refs.pdfRef.exportPage1();
    },
    outPutPdfFn () {
      this.$refs.pdfRef.exportPage();
    },
    exportPDF() {
      this.$refs.pdfRef.exportPDF();
    },
    goPrint() {
      this.$refs.pdfRef.goPrint();
    },

    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](
          `${this.$t('BusinessPurchaseEntryComView.purchase')}${this.text}${this.$t('BusinessPurchaseEntryComView.one')}${this.$route.query.code}${this.$t('BusinessPurchaseEntryComView.log')}`,
          {
            defaultQuery: {
              recordId: this.data.id,
              recordType: this.pageType === 'inform' ? 'STOCKIN' : 'STOCKIN_RESULT',
            },
            search: [],
          },
        ),
      );
    },
    handleClose() {
      this.cancel();
    },
    getData() {
      purchaseApi[this.pageType === 'inform' ? 'getStockinsDetail' : 'stockinResultsDetail']({
        // id: this.$route.query.id,
        code: this.$route.query.code,
      }).then(res => {
        if (!res.failed) {
          this.data = res;
          this.data.goodsList = res.goodsList.map(v => {
            return {
              ...v,
              ...v.rpcGoodsResVO,
              volumeUnit: 'cm³',
              volume: this.getVolume(v.rpcGoodsResVO),
              warehouse: v.warehouseCode,
            };
          });
          this.freight[0].totalTaxAmount = res.freightTax;
          this.freight[0].netAmount = res.freight;
          this.freight[0].grossAmount = res.totalFreight;
          this.freight[0].tax = res.taxRate;
          this.freight[0].taxGroup = res.taxCode;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-center {
  justify-content: left;
}
.numBox {
  position: relative;
  flex: 0 0 150px;
  padding-bottom: 15px;
}
.numBox p {
  font-size: 12px;
}
.numBox::after {
  position: absolute;
  content: '';
  height: 5px;
  bottom: 0;
  left: 15px;
  right: 15px;
  display: block;
  // background-color: red;
}
.numBox:nth-child(1):after {
  background-color: $pink;
}
.numBox:nth-child(2):after {
  background-color: $green;
}
.numBox:nth-child(3):after {
  background-color: $sub-dark;
}
.numBox:nth-child(4):after {
  background-color: yellowgreen;
}
</style>
